// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-datetime {
  margin: 0 auto;
  background: #f8f9fb;
}

.date-content {
  width: 100%;
  float: none;
  z-index: 9;
}

.time-content {
  width: 100%;
  float: none;
}

.label-date {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}

.label-time {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}

.buttonPWA {
  display: none;
}

.buttonMobile {
  display: block;
}

@media (min-width: 960px) {
  .label-date {
    display: none;
  }
  .label-time {
    display: none;
  }
  .date-content {
    width: 50%;
    float: left;
  }
  .time-content {
    width: 50%;
    float: right;
  }
  .time-pwa {
    padding-top: 12%;
  }
  .buttonPWA {
    display: block;
  }
  .buttonMobile {
    display: none;
  }
}
.boxx-btn {
  text-transform: uppercase;
}

.custom-title {
  color: var(--ion-color-light) !important;
}

.enable-item {
  border-radius: 0px;
  border: none;
}
.enable-item ion-label {
  color: #425F81 !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: relative;
  top: 3px;
}
.enable-item .hour {
  color: #12384F !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  position: relative;
  top: 3px;
}

#content-pad {
  padding: 16px 24px;
  background: #fff;
}
#content-pad .title {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
#content-pad hr {
  background: #D8D8D8;
}

ion-toggle {
  --background: #dfdfdf !important;
  --background-checked: var(--ion-color-primary) !important;
  --handle-background: #ffffff !important;
  --handle-background-checked: #fff !important;
}

ion-toggle[slot=end] {
  margin-top: 12px;
  margin-bottom: 12px;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/datetime-notifications/datetime-notifications-picker.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAGA;EACI;IACI,aAAA;EAAN;EAGE;IACI,aAAA;EADN;EAIE;IACI,UAAA;IACA,WAAA;EAFN;EAKE;IACI,UAAA;IACA,YAAA;EAHN;EAME;IACI,gBAAA;EAJN;EAOE;IACI,cAAA;EALN;EAQE;IACI,aAAA;EANN;AACF;AASA;EACI,yBAAA;AAPJ;;AAUA;EACI,wCAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,YAAA;AAPJ;AASI;EACI,yBAAA;EACA,6CAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAPR;AAUI;EACI,yBAAA;EACA,6CAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AARR;;AAYA;EACI,kBAAA;EACA,gBAAA;AATJ;AAWI;EACI,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AATR;AAYI;EACI,mBAAA;AAVR;;AAcA;EACI,gCAAA;EACA,yDAAA;EACA,uCAAA;EACA,4CAAA;AAXJ;;AAcA;EACI,gBAAA;EACA,mBAAA;EACA,UAAA;AAXJ","sourcesContent":["ion-datetime {\n    margin: 0 auto;\n    background: #f8f9fb;\n}\n\n.date-content {\n    width: 100%;\n    float: none;\n    z-index: 9;\n}\n\n.time-content {\n    width: 100%;\n    float: none;\n}\n\n.label-date {\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n}\n\n.label-time {\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n}\n\n.buttonPWA {\n    display: none;\n}\n\n.buttonMobile {\n    display: block;\n}\n\n//PWA\n@media (min-width: 960px) {\n    .label-date {\n        display: none;\n    }\n\n    .label-time {\n        display: none;\n    }\n\n    .date-content {\n        width: 50%;\n        float: left;\n    }\n\n    .time-content {\n        width: 50%;\n        float: right;\n    }\n\n    .time-pwa {\n        padding-top: 12%;\n    }\n\n    .buttonPWA {\n        display: block;\n    }\n\n    .buttonMobile {\n        display: none;\n    }\n}\n\n.boxx-btn {\n    text-transform: uppercase;\n}\n\n.custom-title {\n    color: var(--ion-color-light) !important;\n}\n\n.enable-item {\n    border-radius: 0px;\n    border: none;\n\n    ion-label{\n        color: #425F81 !important;\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: Poppins !important;\n        font-size: 16px !important;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        position: relative;\n        top: 3px;\n    }\n\n    .hour{\n        color: #12384F !important;\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: Poppins !important;\n        font-size: 16px !important;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        position: relative;\n        top: 3px;\n    }\n}\n\n#content-pad {\n    padding: 16px 24px;\n    background: #fff;\n\n    .title {\n        color: var(--text-BODY, #2C4051);\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: 'Poppins';\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n    }\n\n    hr {\n        background: #D8D8D8;\n    }\n}\n\nion-toggle {\n    --background: #dfdfdf !important;\n    --background-checked: var(--ion-color-primary) !important;\n    --handle-background: #ffffff !important;\n    --handle-background-checked: #fff !important;\n}\n\nion-toggle[slot=end] {\n    margin-top: 12px;\n    margin-bottom: 12px;\n    padding: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
